import {
  GET_TUTORS,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialTutors = {
  professionalProfile:[],
  tutors: [],
  tutorCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const tutorsReducer = (state = initialTutors, action) => {
  switch (action.type) {
    case GET_TUTORS:
      return {
        ...state,
        tutors: action.payload.tutors.map((tutor) => {
          return {
            ...tutor,

            updatedAtFormatted: moment(tutor.createdAt).format("ll"),
          };
        }),
        tutorCount: action.payload.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default tutorsReducer;
